// extracted by mini-css-extract-plugin
export default {"general":"smallTile_general__kAL27","image":"smallTile_image__sY5td","container":"smallTile_container__Kznnf","name":"smallTile_name__GExpY","link":"smallTile_link__HQyuz"};